export const environment = {
  apiUrl: 'https://app-api-dev.ilwu.org',
  production: false,
};
